<template>
  <div class="mw-1000 mx-auto py-6 px-8">
    <h-loading v-if="isLoading" />

    <div v-else>
      <QuoteHeader
        :vendor="vendor"
        :quoteWasNotFound="quoteWasNotFound"
        :version="version"
      />

      <QuoteMessages
        :isOverdue="isOverdue"
        :isQuotePending="isQuotePending"
        :isQuoteAlreadyPaid="isQuoteAlreadyPaid"
        :quoteWasNotFound="quoteWasNotFound"
        :paymentMethod="paymentMethod"
      />

      <!-- TABLE QUOTE ITEMS -->
      <div v-if="!quoteWasNotFound">
        <p>
          {{
            $t('quote.hint.addressAndCode', {
              address: quoteItems && quoteItems.realty_address,
              code: quoteItems && quoteItems.realty_code,
            })
          }}
        </p>

        <p>
          {{ $t('quote.hint.afterPaymentGetInTouch') }}
        </p>

        <v-spacer class="my-10" />

        <QuotePaymentList
          :version="version"
          :quoteItemsList="quoteItemsList"
        />

        <v-divider />

        <QuotePrices
          v-if="version != 2"
          :quotes="quotes"
          :quoteItems="quoteItems"
          :isQuoteAlreadyPaid="isQuoteAlreadyPaid"
        />

        <QuotePricesV2
          v-else
          :quotes="quotes"
          :quoteItems="quoteItems"
          :isQuoteAlreadyPaid="isQuoteAlreadyPaid"
        />

        <v-spacer class="d-print-none mt-5" />

        <!-- button  pay -->
        <div
          v-if="!isQuotePaid && !isQuoteAlreadyPaid && !isOverdue"
          :class="breakPointChange"
          class="ml-auto text-right d-print-none"
        >
          <v-btn
            @click="selectPaymentMethod"
            :loading="isLoading"
            color="primary"
            elevation="0"
            block
            large
          >
            {{ buttonLabel }}
          </v-btn>
        </div>
        <!-- /button  pay -->
      </div>
      <!-- /TABLE QUOTE ITEMS -->
    </div>

    <QuotePaymentModal />

    <img
      :src="poweredBy"
      :alt="$t('quote.label.poweredByAlt')"
      class="quote__logo--footer mb-8"
    />
  </div>
</template>

<script>
import poweredBy from '@/assets/images/logo-powered-by.svg'
import { mapGetters, mapActions, mapMutations } from 'vuex'

import QuoteHeader from '@/views/quote/components/QuoteHeader'
import QuotePrices from '@/views/quote/components/QuotePrices'
import QuotePricesV2 from '@/views/quote/components/QuotePricesV2'
import QuoteMessages from '@/views/quote/components/QuoteMessages'
import QuotePaymentList from '@/views/quote/components/QuotePaymentList'
import QuotePaymentModal from '@/views/quote/components/QuotePaymentModal'
import QuotePricesTotal from './quote/components/QuotePricesTotal.vue'

export default {
  name: 'BudgetList',

  components: {
    QuoteHeader,
    QuotePrices,
    QuotePricesV2,
    QuoteMessages,
    QuotePaymentList,
    QuotePaymentModal,
    QuotePricesTotal
},

  computed: {
    ...mapGetters([
      'quotes',
      'isLoading',
      'quoteItems',
      'payWithFci',
      'quoteWasNotFound',
      'quoteItemsList',
      'isQuotePaid',
    ]),

    breakPointChange() {
      return !this.$vuetify.breakpoint.mobile && 'mw-400'
    },

    vendor() {
      return {
        logo: this.quotes?.price_table?.vendor?.logo?.url,
        name: this.quotes?.price_table?.vendor?.name,
        email: this.quotes?.price_table?.vendor?.email,
        phone: this.quotes?.price_table?.vendor?.customer_service_phone,
        document: this.quotes?.price_table?.vendor?.document,
      }
    },

    buttonLabel() {
      if (this.isQuotePending) return this.$t('quote.action.useAnotherMethod')
      if (this.payWithFci) return this.$t('quote.action.acceptQuote')
      return this.$t('quote.action.pay')
    },

    version() {
      return this.quoteItems?.version ?? 1
    },

    status() {
      if (!this.quoteItems?.charge) return
      return this.quoteItems?.charge?.installments[0]?.status
    },

    paymentMethod() {
      if (!this.quoteItems?.charge_summary) return
      return this.quoteItems?.charge_summary?.payment_method
    },
  },

  methods: {
    ...mapActions([
      'fetchQuotes',
      'openModal',
    ]),

    ...mapMutations([
      'setSuccessData',
      'setQuotePaymentType',
      'setQuotePaymentStatus',
      'setShowQuoteMessageSuccess',
    ]),

    selectPaymentMethod() {
      this.setQuotePaymentType(null)
      this.setQuotePaymentStatus(null)
      this.setShowQuoteMessageSuccess(false)
      this.openModal('QUOTE_PAYMENT_MODAL')
    },

    checkChargeStatus(status) {
      this.isQuoteAlreadyPaid = false
      this.isQuotePending = false
      this.isOverdue = false

      status === 'RECEIVED' || status === 'CONFIRMED'
        ? (this.isQuoteAlreadyPaid = true)
        : (this.isQuoteAlreadyPaid = false)

      status === 'PENDING'
        ? (this.isQuotePending = true)
        : (this.isQuotePending = false)

      status === 'OVERDUE'
        ? (this.isOverdue = true)
        : (this.isOverdue = false)
    },

    handleOpenModalWithPixPaymentSelected() {
      this.setQuotePaymentType('ASAAS_PIX')
      this.openModal('QUOTE_PAYMENT_MODAL')
      this.setQuotePaymentStatus('PENDING')
      this.setShowQuoteMessageSuccess(false)
      this.setSuccessData(this.quotes.charge)
    }
  },

  watch: {
    quoteItems() {
      this.$nextTick(() => this.checkChargeStatus(this.status))
    },
  },

  data() {
    return {
      poweredBy,

      isQuoteAlreadyPaid: false,
      isQuotePending: false,
      isOverdue: false,
    }
  },

  mounted() {
    const serviceReportId = this.$route?.params?.id
    serviceReportId && this.fetchQuotes(serviceReportId)
  },
}
</script>

<style scoped>
@media print {
  @page {
    margin: 0;
  }
  body {
    margin: 1.6cm;
  }
}
</style>
